import { render, staticRenderFns } from "./trans-land-info.html?vue&type=template&id=77a00ea9&scoped=true&external"
import script from "./trans-land-info.js?vue&type=script&lang=js&external"
export * from "./trans-land-info.js?vue&type=script&lang=js&external"
import style0 from "./trans-land-info.scss?vue&type=style&index=0&id=77a00ea9&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a00ea9",
  null
  
)

export default component.exports